import React from 'react'
import { Navigate } from 'react-router-dom'

import useAuth from '@/hooks/useAuth'

interface GuestGuardType {
  children: React.ReactNode
}

// For routes that can only be accessed by unauthenticated users
function GuestGuard({ children }: GuestGuardType) {
  const { isAuthenticated, isInitialized, creatingUser } = useAuth()

  if (isInitialized && isAuthenticated && !creatingUser) {
    return <Navigate to="/" />
  }

  return <>{children}</>
}

export default GuestGuard
